import SuperFetch from '../../superFetch.js';

class EventApi {
  /**
   *  [진행중인 기획전] 진행중인 기획전 리스트 엑셀 다운로드 요청하기
   */
  getInProgressEventExcelDownload = (data) => SuperFetch.post('/event/inProgress/list/excel/download', data);

  /**
   *  [전체 기획전] 전체 기획전 리스트 엑셀 다운로드 요청하기
   */
  getAllEventExcelDownload = (data) => SuperFetch.post('/event/all/list/excel/download', data);

  /**
   *  [진행중인 기획전, 전체 기획전] 태그 리스트 요청하기
   */
  getEventTagColumnTagList = (data) => SuperFetch.post('/event/all/list/tag', data);

  /**
   *  [기획전 등록] 기획전 상품 엑셀 다운로드
   */
  getSelectedEventProductExcelDownload = (data) =>
    SuperFetch.post('/event/insert/preparation/product/list/excel/download/selected', data);

  /**
   *  [기획전 등록] 기획전 상품 엑셀 다운로드
   */
  getEventProductExcelDownload = (data) =>
    SuperFetch.post('/event/insert/preparation/product/list/excel/download', data);

  /**
   *  [기획전 등록] 기획전 상품 엑셀 업로드
   */
  setEventProductExcelListUpload = (data) =>
    SuperFetch.post('/event/insert/preparation/product/list/excel/upload', data);

  /**
   *  [기획전 등록,편집] 전체 태그 리스트 엑셀 다운로드
   */
  getEventTagAllListExcelDownload = (data) =>
    SuperFetch.post('/event/insert/preparation/tag/list/excel/download', data);

  /**
   *  [기획전 등록,편집] 선택 태그 리스트 엑셀 다운로드
   */
  getEventTagSelectedListExcelDownload = (data) =>
    SuperFetch.post('/event/insert/preparation/tag/list/excel/download/selected', data);

  /**
   *  [기획전 등록,편집] 태그 엑셀 업로드
   */
  setEventTagExcelUpload = (data) => SuperFetch.post('/event/insert/preparation/tag/list/excel/upload', data);
}

export default new EventApi();
